<img alt="ProcessManager" [src]="logoSrc" style="max-width: 400px;">
